import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../common';
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';

import { ScheduleSelector } from './schedule-selector/schedule-selector.component';
import { TimePicker } from './time-picker/time-picker.component';
import { TimezonePicker } from './timezone-picker/timezone-picker.component';
import { KeyValuePipe, FilterPipe, StatusSuccessPipe, StorageRenderPipe, StatusStringFormatterPipe, DateRendererPipe, VappStatusRenderPipe } from './pipes';

@NgModule({
    declarations: [
        ScheduleSelector,
        TimePicker,
        TimezonePicker,
        KeyValuePipe,
        FilterPipe,
        StatusSuccessPipe,
        StorageRenderPipe,
        StatusStringFormatterPipe,
        DateRendererPipe,
        VappStatusRenderPipe
    ],
    imports: [
        BrowserModule,
        FormsModule,
        VcaCommonModule,
        TranslateModule,
        ClarityModule.forRoot(),
        Ng2DatetimePickerModule
    ],
    providers: [
    ],
    exports: [
        ScheduleSelector,
        TimePicker,
        TimezonePicker,
        KeyValuePipe,
        FilterPipe,
        StatusSuccessPipe,
        StorageRenderPipe,
        StatusStringFormatterPipe,
        DateRendererPipe,
        VappStatusRenderPipe
    ]

})
export class DpsCommonModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-common/dataprotection-common.module.ts